import axios from "axios";

export const packageApiBaseURL =
  process.env.REACT_APP_PACKAGE_API_BASE_URL || "https://api.physica.fit/api/v1";

const packageApi = axios.create({
  baseURL: packageApiBaseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const loginWithIdToken = async (idToken) =>
  packageApi.post("/client/login", { idToken });

export const lookupPackagePatients = async (phone_number) =>
  packageApi.post("/package/purchase/patient-lookup", { phone_number });

export const createPackageLead = async (payload) =>
  packageApi.post("/package/purchase/new-lead", payload);

export const fetchPurchasePackages = async () =>
  packageApi.get("/package/purchase/packages");

export const buildPackageReview = async (payload) =>
  packageApi.post("/package/purchase/review", payload);

export const createPackageOrder = async (payload) =>
  packageApi.post("/package/purchase/create-order", payload);

export const verifyPackagePayment = async (payload) =>
  packageApi.post("/package/purchase/verify-payment", payload);

export default packageApi;
